module.exports = __webpack_public_path__ + "img/caparol.2a20e2f6.png";